function OpenWindow(_this, paraList, AccessType) {
    _this.$store.commit('setRouteParam', paraList);
    _this.$store.commit('setAccessType', AccessType);
    window.open('hunt/CameraFunc.html', 'Shinsoft', 'height=402,width=640,menubar=no,resizable=no,status=no,toolbar=no,location=no,scrollbars=no');
}
function SetClearFunction(_this) {
    if (!window.HTClearFunction){
        window.HTClearFunction = function () {
            _this.$store.commit('setRouteParam', []);
            _this.$store.commit('setAccessType', '');
        };
    }
}
function RemoveClearFunction() {
    window.HTClearFunction = undefined;
}
export default {
    OpenWindow,
    SetClearFunction,
    RemoveClearFunction,
}